import { render, staticRenderFns } from "./society.vue?vue&type=template&id=187240f4"
import script from "./society.vue?vue&type=script&lang=js"
export * from "./society.vue?vue&type=script&lang=js"
import style0 from "./society.vue?vue&type=style&index=0&id=187240f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports